// shared css require needs to come first so component css can override shared css without needing !important
require('@alltrails/shared/sharedCss.css');

import { lazy } from 'react';
import AccountLinks from 'components/profile/AccountLinks';
import AlgoliaSearchBoxErbWrapper from 'components/AlgoliaSearchBox/AlgoliaSearchBoxErbWrapper';
import AvatarStackContainer from 'components/profile/AvatarStackContainer';
import FacebookSettings from 'components/FacebookSettings';
import FooterWrapper from 'components/FooterWrapper';
import GeneralPrivacyPolicy from 'components/privacyPolicy/GeneralPrivacyPolicy';
import Gift from 'pages/Gift/Gift';
import GlobalActions from 'components/GlobalActions';
import HomePage from 'pages/HomePage';
import Login from 'pages/Login';
import MobileHomeLink from 'components/NavigationWrapper/MobileHomeLink';
import NavigationWrapper from 'components/NavigationWrapper';
import NotificationsSettings from 'components/NotificationsSettings';
import Pro from 'components/Pro';
import ProfileSidebar from 'components/profile/ProfileSidebar';
import ProfileSlidingTabs from 'components/profile/ProfileSlidingTabs';
import ProMarketingFeatures from 'components/ProMarketingFeatures';
import PlusWelcome from 'components/PlusWelcome';
import QuoteRotator from 'components/QuoteRotator';
import RedemptionPage from 'components/RedemptionPage';
import SignUp from 'pages/SignUp';
import UpdatePaymentForm from 'components/forms/UpdatePaymentForm';

import withSuspense from '../hocs/withSuspense';

const Mobile = lazy(() => import('../pages/Mobile'));

const ReactRailsUJS = require('react_ujs');

const context = {
  AlgoliaSearchBoxErbWrapper,
  AccountLinks,
  AvatarStackContainer,
  FacebookSettings,
  FooterWrapper,
  GeneralPrivacyPolicy,
  Gift,
  GlobalActions,
  HomePage,
  Login,
  Mobile: withSuspense(Mobile, 'Mobile'),
  MobileHomeLink,
  NavigationWrapper,
  NotificationsSettings,
  Pro,
  ProfileSidebar,
  ProfileSlidingTabs,
  ProMarketingFeatures,
  PlusWelcome,
  QuoteRotator,
  RedemptionPage,
  SignUp,
  UpdatePaymentForm
};

ReactRailsUJS.getConstructor = className => context[className];
